<template>

  <div>
    <section class="">
          <div class="level-item">
        <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />

      </div>
<div class="level-item">

<p class="title is-2">Online Classes</p>
</div>
<br>
    </section>
    <section class="container section page-header section is-main-section">
<p class="title is-4" style=" text-align: center;">Class session logged out successfully. Thank you !!</p>
    </section>

  </div>

</template>

<script>
export default {
  name: 'LogoutPage',
  props: ['referenceID'],
  created: async function () {
  },
  methods: {
  }
}
</script>
